<template lang="pug">
    div.layout
        navbar
        div.main-container(:class="showPage ? '' : 'no-footer'")
            sidebar(:showPage="showPage")
            app-main
        //- 第一次登陆强制设置登陆密码
        modify-password(
            v-if="!this.userInfo.hasPassword"
            :passwordData="passwordData"
            @setPassWordCb="setShopInfo"
            @closeSetPassWordCb="versionUpdate"
        )
        ConfirmDialog(
            ref="confirmDialog"
            :hasCancelButton="false"
            :showClose="false"
            operateName=""
            @confirmSubmit="confirmSubmit"
            confirmButtonText="返回登录"
        )
            div(slot="text-desc")
                div.shop-setting-tips {{ reLoginTxt }}
        ConfirmDialog(
            ref="reSelectStore"
            :hasCancelButton="false"
            :showClose="false"
            operateName=""
            @confirmSubmit="selectOrganization"
            confirmButtonText="重新选店"
        )
            div(slot="text-desc")
                div.shop-setting-tips {{ reSelectStoreTxt }}
        //- 店铺第一次登陆，强制设置店铺信息  优先级小于强制设置密码
        el-dialog(
            title="店铺设置"
            :visible.async="visible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            custom-class="layout-shop-dialog"
            width="680px"
            center
        )
            ShopSetting(
                type="dialog"
                @setInfoSuccess="setInfoSuccess"
            )
        page-footer(v-if="showPage" :pageStyle="{ 'padding': '16px 16px 11px 16px' }")
        select-organization(
            :selectOrgData="selectOrgData"
            @refresh="refresh"
            @closeDialog="closeDialog"
            v-if="selectOrgData.show"
        )
        //- 版本更新说明
        version-update(
            v-if="updateData.show"
            :updateData="updateData"
        )
</template>
<script>
import { PageFooter } from '@klicen/component-vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import { loginApis, versionApis } from '@/api';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
// eslint-disable-next-line
import notification from './components/notification';
import selectOrganization from '../login/components/SelectOrganization';

import {
    Navbar,
    Sidebar,
    AppMain,
    ModifyPassword,
    VersionUpdate,
} from './components/index';
import ShopSetting from '../shopSetting/home/components/ShopSetting';

let notifyTimer = null;
let versionUpdateTimer = null;
export default {
    name: 'Layout',
    components: {
        Navbar,
        Sidebar,
        AppMain,
        ModifyPassword,
        ShopSetting,
        ConfirmDialog,
        PageFooter,
        selectOrganization,
        VersionUpdate,
    },
    data() {
        return {
            passwordData: {},
            selectOrgData: {},
            updateData: {
                show: false,
            },
            visible: false,
            reLoginTxt: '',
            reSelectStoreTxt: '',
            vusStatusTxt: {
                INIT: '未合作',
                UNDERWAY: '合作中',
                PAUSE: '暂停合作',
                STOP: '停止合作',
            },
            showPage: true,
        };
    },
    computed: {
        ...mapState('user', [
            'userInfo',
            'userOrgsType',
            'getAuthority',
            'orgList',
            'isCheck',
        ]),
        ...mapGetters('user', [
            'getAuthority',
        ]),
        ...mapActions('user', [
            'LogOut',
        ]),
    },
    watch: {
        $route(route) {
            // 监听路由变化，指定相关页面不显示页脚
            this.setShowFooter(route);
        },
    },
    created() {
        this.closeNotify();
        this.setShowFooter(this.$route);
    },
    mounted() {
        this.passwordData = {
            model: 'firstSet',
            userId: this.userInfo.id,
            show: true,
        };
        this.rotateNotify();
        this.setShopInfo(true);
    },
    destroyed() {
        clearInterval(notifyTimer);
        notifyTimer = null;
        notification.removeNotify();

        clearInterval(versionUpdateTimer);
        versionUpdateTimer = null;
    },
    methods: {
        ...mapActions('user', [
            'setIsCheck',
        ]),
        // 每小时判断一次是否需要获取版本更新
        initRotateVersionUpdate() {
            this.rotateVersionUpdate();
            versionUpdateTimer = setInterval(() => {
                this.rotateVersionUpdate();
            }, 60 * 60 * 1000);
        },
        // 获取版本更新
        async rotateVersionUpdate() {
            // 每12小时获取一次更新
            if (localStorage.getItem('GET_VERSION_TIMESTAMP') && this.isTime(localStorage.getItem('GET_VERSION_TIMESTAMP'))) {
                await this.getVersionUpdate();
            }
            // 登陆/刷新获取一次更新
            if (this.isCheck || JSON.stringify(this.isCheck) === 'null') {
                try {
                    await this.getVersionUpdate();
                } catch (err) {
                    throw new Error(err);
                } finally {
                    await this.setIsCheck(false);
                }
            }
            if (!localStorage.getItem('GET_VERSION_TIMESTAMP')) {
                localStorage.setItem('GET_VERSION_TIMESTAMP', (new Date()).getTime());
            }
        },
        async getVersionUpdate() {
            try {
                const { data } = await versionApis.checkUpdate();
                if (data) this.showVersionUpdate(data);
            } catch (err) {
                throw new Error(err);
            } finally {
                localStorage.setItem('GET_VERSION_TIMESTAMP', (new Date()).getTime());
            }
        },
        showVersionUpdate(data) {
            this.updateData.data = data;
            this.updateData.show = true;
        },
        isTime(oldTime) {
            const now = new Date();
            return now.getTime() - oldTime >= 60 * 60 * 1000 * 12;
        },
        versionUpdate() {
            // 版本更新弹窗 优先级小于设置密码和店铺设置
            if (!this.visible) {
                this.initRotateVersionUpdate();
            }
        },
        // 每6秒获取一次Notification
        rotateNotify() {
            if (process.env.NODE_ENV !== 'development') {
                if (this.getAuthority('CollisionMessage', 'Desk')) {
                    notifyTimer = setInterval(() => {
                        notification.getNotification();
                    }, 6000);
                }
            }
        },
        // 界面刷新时关闭桌面通知
        closeNotify() {
            window.addEventListener('beforeunload', () => {
                notification.beforeunloadClose();
            });
        },
        confirmSubmit() {
            this.LogOut();
        },
        /**
         * 首次登陆设置密码完成后-->首次登陆设置店铺信息（切店时同逻辑）
         * 切店后-->首次登陆设置店铺信息
         */
        async setShopInfo(mounted) {
            // 多店模式下不处理, 集团模式下不处理
            if (this.userInfo.mode !== 1) return;

            const hasSet = this.userInfo.orgs.find(val => val.orgId === this.userInfo.lastLoginOrgId);
            if (hasSet.orgType !== 'STORE') return;

            const hasPassword = await this.getPasswordStatus();
            if (!hasPassword) return;

            if (!hasSet.infoSet) {
                if (!this.getAuthority('ShopSetting', 'Read') || !this.getAuthority('ShopSetting', 'Update')) {
                    const txt1 = '当前店未进行店铺设置，请联系有店铺设置权限的管理员登录设置,设置后方可正常登录';
                    const txt2 = '当前店已暂停合作，因未进行店铺设置，暂时无法进入';
                    if (this.userInfo.canSwitch) this.showTipsByStore('multipleStore', txt1, txt2);
                    else this.showTipsByStore('singleStore', txt1, txt2);

                    // eslint-disable-next-line
                        return;
                }
                this.visible = !hasSet.infoSet;
            }
            // 设置密码回调时不初始化，用户点击’知道了’才初始化
            if (mounted && hasPassword && hasSet.infoSet) this.initRotateVersionUpdate();
        },
        showTipsByStore(func, txt1, txt2) {
            return this[func](txt1, txt2);
        },
        multipleStore(txt1, txt2) {
            const store = this.userInfo.orgs.find(val => val.orgId === this.userInfo.lastLoginOrgId);
            this.reSelectStoreTxt = store.vusStatus === 'UNDERWAY' ? txt1 : txt2;
            this.$refs.reSelectStore.dialogVisible = true;
        },
        singleStore(txt1, txt2) {
            this.reLoginTxt = this.userInfo.orgs[0].vusStatus === 'UNDERWAY' ? txt1 : txt2;
            this.$refs.confirmDialog.dialogVisible = true;
        },
        async getPasswordStatus() {
            const { data } = await loginApis.getUserInfo({
                orgType: this.userOrgsType,
            });
            return data ? data.hasPassword : null;
        },
        setInfoSuccess() {
            this.visible = false;
            this.initRotateVersionUpdate();
        },
        // 选店
        selectOrganization() {
            this.selectOrgData = {
                show: true,
                type: 'edit',
                id: this.userInfo.id,
                orgId: this.userInfo.lastLoginOrgId,
                orgType: this.userOrgsType,
                mode: this.userInfo.mode,
                orgList: this.orgList,
            };
            this.$refs.reSelectStore.dialogVisible = false;
        },
        closeDialog() {
            this.$refs.reSelectStore.dialogVisible = true;
        },
        refresh() {
            this.$router.push('/')
                .finally(() => {
                    window.location.reload();
                });
        },
        setShowFooter(route) {
            // 隐藏footer栏
            const hideFooterNames = [
                'AutoInsuranceLeadsOrder',
                'VehicleInsuranceListDetail',
                'VehicleInsuranceCluesListDetail',
                'AutoInsuranceOrderListDetail',
                'AutoInsurancePolicyListDetail',
                'AutoInsuranceQuoteListDetail',
            ];
            const isHide = hideFooterNames.includes(route.name);
            this.showPage = !isHide;
        },
    },
};
</script>
<style scoped lang="scss">
    .main-container {
        display: flex;
        height: calc(100% - 126px);
        > .sidebar {
            flex-shrink: 0;
            width: 200px;
            height: 100%;
        }
        > .app-main {
            width: calc(100% - 200px);
            height: 100%;
            flex-shrink: 0;
        }
    }
    .no-footer {
        height: 100%;
    }
    .shop-setting-tips {
        text-align: center;
    }
</style>
<style lang="scss">
    .layout {
        .page-footer {
            bottom: 5px !important;
        }
        .layout-shop-dialog {
            .el-dialog__body {
                padding: 0 !important;
                height: 670px;
                overflow-y: scroll;
                overflow-x: hidden;
            }
        }
    }
</style>
